// Utility function to get auth token from localStorage or AuthContext
export const getAuthToken = () => {
  try {
    const userStr = localStorage.getItem("user");
    if (userStr) {
      const user = JSON.parse(userStr);
      const token = user?.token;
      if (!token) {
        // Token missing
      }
      return token || null;
    }
  } catch (error) {
    // Error handling
  }
  return null;
};

// Utility function to get auth headers with token
export const getAuthHeaders = (includeContentType = true) => {
  const token = getAuthToken();
  const headers = {};

  if (includeContentType) {
    headers["Content-Type"] = "application/json";
  }

  if (token) {
    // Send token with Bearer prefix for better compatibility
    // Remove any existing Bearer prefix to avoid double prefixing
    const cleanToken = token.startsWith("Bearer ") ? token.slice(7) : token;
    headers["Authorization"] = `Bearer ${cleanToken}`;
  } else {
    console.warn("getAuthHeaders: No token available, request may fail with 401");
  }

  return headers;
};

// Utility function to get user object
export const getStoredUser = () => {
  try {
    const userStr = localStorage.getItem("user");
    if (userStr) {
      return JSON.parse(userStr);
    }
  } catch (error) {
    // Silent fail
  }
  return null;
};

